import { lazy, Suspense, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { profileTypes } from '../config/constants/userConstants';

const TopicsView = lazy(() => import('../views/ServicesHistory/components/TopicView'));

export function useTopicRoutes() {
  const { userAssignedTopics } = useSelector((state) => ({
    userAssignedTopics: state.userAssignedTopics?.data,
  }));

  const topics = useMemo(() => {
    if (!userAssignedTopics?.length) return [];
    const customRoutes = userAssignedTopics?.map((item) => ({
      path: `/topic/${item._id}`,
      name: item.name,
      icon: item.icon || 'none',
      profiles: [profileTypes.ADMIN.id, profileTypes.OPERATOR.id, profileTypes.MASTER.id],
      component: () => (
        <Suspense>
          <TopicsView serviceTypes={item.topicInfo?.serviceTypes} />
        </Suspense>
      ),
    }));
    return customRoutes;
  }, [userAssignedTopics]);

  return topics;
}
